const MenteeRegistrationChrome = () => (
    <div className="mdash-chrome mreg-chrome">
        <p className="mdash-crumb">
            Mentorship Module <span aria-hidden="true">›</span> <strong>Registration Form</strong>
        </p>
    </div>
);

export default MenteeRegistrationChrome;
